import api from '../Utils/api'

export const fetchSlackUsersAndChannels = async () => {
  const apiResponse = await api('GET', 'slack/users-channels', null, true)
  return apiResponse
}

export const sendMessage = async (data) => {
  const apiResponse = await api('POST', 'slack/sendMessage', data)
  return apiResponse
}
